import Crud from '../views/Setor/Crud'
import Entity from '../views/Setor/View'

let routes = {
    path: '/setores',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/setores/view/:id?',
            name: 'ViewSetor',
            component: Entity,
            meta: {
                pageTitle: 'Visualizar Setor',
                breadcrumb: [
                    {
                        text: 'Setores',
                        active: false,
                        to: '/setores',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/setores',
            name: 'list-setores',
            component: Crud,
            meta: {
                pageTitle: "Lista de Setores",
                breadcrumb: [
                    {
                        text: "Setores",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
